import { defineStore } from "pinia";
import auctionModel from "@/models/subastaModel";
import loteModel from "@/models/loteModel";

export const useLotesSubastaStore = defineStore("lotesSubasta", {
  state: () => ({
    auction: { id: null, martillero_asignado: null, ubicaciones: [], termino_condicion: null },
    lotes: {
      data: [],
      current_page: 1,
      first_page_url: null,
      from: null,
      last_page: null,
      per_page: 12,
      to: null,
      total: null,
    },
    cargando: false,
  }),
  actions: {
    async obtenerSubastaConLotes(id = this.auction.id) {
      try {
        const auction = await auctionModel.obtenerSubastaConLotes(id);
        Object.assign(this.auction, auction);
      } catch (error) {
        console.error("Error en el store al obtener la auction:", error);
      }
    },

    async obtenerLotesFiltrados(filtros = {}) {
      try {
        this.lotes.data = [];
        this.cargando = true;
        const filtrosClonados = {
          ...filtros,
          page: filtros.page ?? this.lotes.current_page,
          per_page: filtros.per_page ?? this.lotes.per_page,
        };

        // Priorizar el subasta_id explícito del filtro, luego el del store
        const idParaFiltrar = filtros.subasta_id ?? this.auction.id;

        const lotes = await loteModel.obtenerLotes(
          filtrosClonados,
          idParaFiltrar
        );

        if (lotes) {
          Object.assign(this.lotes, lotes);
        }
      } catch (error) {
        console.error("Error al obtener lotes:", error);
        throw error;
      } finally {
        this.cargando = false;
      }
    },
  },
});